import globConfig from '@/config/config';

//获取/设置 localStorage中的token
export const localToken = {

    //获取token
    getToken() {
        let that = this;
        // token缓存名 __USER_TOKEN__
        let tokenValue = localStorage.getItem(globConfig.tokenName);
        return this._decodeLocalToken(tokenValue);
    },


    //保存token
    setToken(value, expire = 0) {

        if (expire === 0) {
            expire = globConfig.tokenExpire; //有效期传入0 使用全局配置
        }

        if (expire <= 10 || expire >= 7776000) { //小于10秒或者大于90天 都变成2小时
            expire = 7200;
        }

        let nowTimestamp = (Date.parse(new Date()) / 1000); //当前时间戳 //后端可以考虑返回服务器的时间
        let expireTime = (nowTimestamp + expire) - 2; //这里转换成过期的具体时间戳

        value += '#expire_time@' + expireTime + '#'; //连接过期时间戳和具体的token值
        return localStorage.setItem(globConfig.tokenName, value, expire);

    },
    // 记录tenantID
    getTenant() {
        return localStorage.getItem(globConfig.setTenant);
    },
    setTenant(value) {
        return localStorage.setItem(globConfig.setTenant, value);
    },
    // 记录登录商户名称
    getUser() {
        return localStorage.getItem(globConfig.setUser);
    },
    setUser(value) {
        return localStorage.setItem(globConfig.setUser, value);
    },
    // 记录现烤间
    getWorkShopName() {
        return localStorage.getItem(globConfig.setWorkShopName);
    },
    setWorkShopName(value) {
        return localStorage.setItem(globConfig.setWorkShopName, value);
    },
    // 记住登录信息
    getRememberInfo() {
      return localStorage.getItem(globConfig.rememberInfo);
    },
    setRememberInfo(value) {
      return localStorage.setItem(globConfig.rememberInfo, value);
    },
    // 记录是否打开模态框
    getIsModal() {
      return localStorage.getItem(globConfig.isModal);
    },
    setIsModal(value) {
      return localStorage.setItem(globConfig.isModal, value);
    },
    _decodeLocalToken(tokenValue) {

        //token值无效
        if (!tokenValue) {
            return '';
        }
        let pattern = /(.+?)#expire_time@(.+?)#/i;
        let r = tokenValue.match(pattern);

        if (null !== r && r.length > 2) {
            let expire_time = r[2] || 0;
            //token 过期
            if (expire_time < (Date.parse(new Date()) / 1000)) {
                return '';
            }
            return r[1];
        }

        return '';
    },

    clearLocal() {
        // return localStorage.clear()
        localStorage.removeItem(globConfig.tokenName);
        localStorage.removeItem(globConfig.setUser);
        
        return true
    },// 导出数据
    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
    },
}


// WEBPACK FOOTER //
// ./src/libs/util.js